import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
import { ref, computed, reactive, onMounted, watch, onUnmounted, nextTick, toRaw } from 'vue';
import MgMenuItem from './mg-menu-item.vue';
export default {
  __name: 'mg-menu',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    autoHide: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: () => []
    },
    pos: {
      type: Object,
      default: () => ({
        x: '100px',
        y: '100px',
        position: 'absolute'
      })
    },
    // 子菜单弹出方向,right|left,默认右则
    direction: {
      type: String,
      default: 'right',
      validator: val => ['left', 'right'].includes(val)
    }
  },
  emits: ['click', 'outsideClick', 'itemClick', 'mouseleave', 'mouseenter', 'update:show', 'menuSize', 'itemMouseenter', 'itemMouseleave'],
  setup(__props, {
    emit: __emit
  }) {
    const menuRef = ref();
    const selectItem = ref();
    const stateShow = ref(false);
    const props = __props;
    const emit = __emit;
    const menuGroups = computed(() => {
      const groups = [];
      let prev = [];
      for (const item of props.items) {
        const {
          title
        } = item;
        if (!title) continue;else if (title === '--') {
          if (prev.length) {
            groups.push(prev);
            prev = [];
            continue;
          }
        }
        prev.push(item);
      }
      if (prev.length) {
        groups.push(prev);
      }
      return groups;
    });
    const itemIsActive = computed(() => item => {
      return item === toRaw(selectItem.value);
    });
    const menuStyles = reactive({
      zIndex: 1000,
      left: '100px',
      top: '100px',
      position: 'absolute'
    });
    const menuClasses = computed(() => {
      return {
        'vxe-table--context-menu-wrapper': true,
        'is--visible': stateShow.value,
        'menu-direction-left': props.direction === 'left'
      };
    });
    const hideMenu = () => {
      stateShow.value = false;
      emit('update:show', stateShow.value);
    };
    watch(() => props.pos, val => {
      const {
        x,
        y,
        position = 'absolute'
      } = val || {};
      menuStyles.left = x;
      menuStyles.top = y;
      menuStyles.position = position;
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.show, val => {
      stateShow.value = val;
      if (val) {
        nextTick(() => {
          emitMenuSize();
        });
      }
    }, {
      immediate: true
    });
    const handleItemMouseenter = ({
      item,
      $event
    }) => {
      selectItem.value = item;
      emit('itemMouseenter', {
        item,
        $event
      });
    };
    const handleItemMouseleave = ({
      item,
      $event
    }) => {
      if (!item) {
        selectItem.value = null;
        return;
      }
      if (item.children && item.children.length > 0) {
        return;
      }
      selectItem.value = null;
      emit('itemMouseleave', {
        item,
        $event
      });
    };
    const handleSubItemMouseenter = ({
      item,
      $event
    }) => {
      emit('itemMouseenter', {
        item,
        $event
      });
    };
    const handleSubItemMouseleave = ({
      item,
      $event
    }) => {
      emit('itemMouseleave', {
        item,
        $event
      });
    };
    const handleItemClick = ({
      item,
      $event
    }) => {
      emit('itemClick', {
        item,
        $event
      });
      if (props.autoHide) {
        hideMenu();
      }
    };
    const handleMouseleave = e => {
      emit('mouseleave', {
        $event: e
      });
    };
    const handleMouseenter = e => {
      emit('mouseenter', {
        $event: e
      });
    };
    const handleClick = e => {
      emit('click', e);
    };
    const getMaxZIndex = () => {
      const div = document.body.querySelector('#z-index-manage');
      if (!div) return;
      const zIndexAttr = div.getAttribute('data-m');
      const maxZIndex = Number.parseInt(zIndexAttr) || 1000;
      setMaxZIndex(maxZIndex + 1);
      return maxZIndex + 1;
    };
    const setMaxZIndex = idx => {
      const div = document.body.querySelector('#z-index-manage');
      if (!div) return;
      div.setAttribute('data-m', idx);
    };
    const handleHideMenu = e => {
      // 点击了外部
      if (!menuRef.value.contains(e.target)) {
        if (props.autoHide) {
          hideMenu();
        }
        emit('outsideClick', e);
      }
    };
    const emitMenuSize = () => {
      const $menu = menuRef.value;
      if (!$menu) return;
      const w = $menu.clientWidth;
      const h = $menu.clientHeight;
      emit('menuSize', {
        width: w,
        height: h
      });
    };
    onMounted(() => {
      menuStyles.zIndex = getMaxZIndex();
      document.addEventListener('mousedown', handleHideMenu);
      if (stateShow.value) {
        emitMenuSize();
      }
    });
    onUnmounted(() => {
      document.removeEventListener('mousedown', handleHideMenu);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(menuClasses.value),
        style: _normalizeStyle(menuStyles),
        onMouseleave: handleMouseleave,
        onMouseenter: handleMouseenter,
        onClick: _withModifiers(handleClick, ["stop"]),
        ref_key: "menuRef",
        ref: menuRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuGroups.value, (group, groupIdx) => {
        return _openBlock(), _createElementBlock("ul", {
          key: groupIdx,
          class: "vxe-context-menu--option-wrapper"
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, itemIdx) => {
          return _renderSlot(_ctx.$slots, "render-item", {
            item: item,
            itemIndex: itemIdx
          }, () => [(_openBlock(), _createBlock(MgMenuItem, {
            key: item.name || `item_${groupIdx}_${itemIdx}`,
            data: item,
            active: itemIsActive.value(item),
            onMouseenter: handleItemMouseenter,
            onMouseleave: handleItemMouseleave,
            onSubMouseenter: handleSubItemMouseenter,
            onSubMouseleave: handleSubItemMouseleave,
            onClick: handleItemClick
          }, null, 8, ["data", "active"]))]);
        }), 256))]);
      }), 128))], 38);
    };
  }
};